import { Directive, HostListener } from '@angular/core';

@Directive({
    selector: '[appNumericInput]',
    standalone: true
})
export class NumericInputDirective {
	@HostListener('keypress', ['$event'])
	preventNonNumericalInput(event: KeyboardEvent): void {
		const charStr = event.key;
		if (!charStr.match(/^[0-9]+$/)) {
			event.preventDefault();
		}
	}
}
